import { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

const Register = () => {
  // complete - 폼 상태 관리
  const [formData, setFormData] = useState({
    phoneNumber: '',
    otp: '',
    nickname: '',
    password: '',
    confirmPassword: '',
    faction: 'BLUE'
  });

  // complete - OTP 발송 상태 관리
  const [isOtpSent, setIsOtpSent] = useState(false);

  const [agreements, setAgreements] = useState({
    terms: false,
    privacy: false,
    age: false,
  });

  const [modalContent, setModalContent] = useState(null); // 'terms | 'privacy' | null
  
  const navigate = useNavigate();

  // 약관 데이터 (유저님이 제공한 문구 반영)
  const POLICIES = {
    terms: {
      title: "서비스 이용약관 및 환불 규정",
      content: `
[제 1조 (목적)]
본 약관은 'The Pivot'(이하 "회사")이 제공하는 논리 전장 서비스의 이용과 관련하여 회사와 회원의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

[제 2조 (게시판 운영)]
본 게시판은 화면 상단 로고 아래 'RULES(게시판 안내)'에 따라 운영됩니다.

[제 3조 (포인트 및 결제)]
1. 회원은 '유료 전장 참여, 진영 변경, 타 게시글 신고'를 위해 포인트를 결제하여 충전할 수 있습니다.
2. 포인트는 회사의 서비스 내에서만 사용 가능하며, 타인에게 양도할 수 없습니다.
3. 충전한 포인트의 사용기한은 1년입니다.

[제 4조 (금지행위)]
회원은 욕설, 비방, 허위사실 유포 등 타인의 권리를 침해하는 행위를 해서는 안 되며, 위반 시 계정 이용이 제한될 수 있습니다.

[제 5조 (서비스의 변경 및 중단)]
회사는 천재지변, 시스템 점검 등의 사유로 서비스를 일시 중단할 수 있으며, 이 경우 사전에 공지합니다.

[제 6조 (자동화된 콘텐츠 분석)]
1. 본 서비스는 건전한 게시판 환경을 조성하기 위해 Google Jigsaw의 'Perspective API'를 활용하여 콘텐츠의 유해성(욕설, 비방 등)을 자동으로 분석합니다.
2. AI 분석 결과는 참고용 자료로 제공되며, AI 알고리즘의 특성상 판독에 오류가 발생할 수 있습니다. 회사는 해당 분석 결과의 완전성이나 정확성을 보장하지 않으며, 이에 따른 결과에 대해 법적 책임을 지지 않습니다.

--------------------------------------------------
[환불 규정]
1. 환불 원칙: 결제 후 7일 이내, 사용하지 않은 포인트에 한하여 전액 환불 가능하며, 모든 환불 처리는 이용자가 결제한 수단과 동일한 수단으로 대금을 환급하는 것을 원칙으로 합니다. 결제 수단 이외의 방법(현금 입금 등)으로는 환불이 불가능합니다.
2. 환불 불가: 이미 사용한 포인트, 이벤트나 보상으로 무상 지급받은 포인트, 결제 후 7일 경과 건.
3. 환불 절차: MYPAGE의 '포인트 충전 및 사용 내역 관리 - 결제/환불 내역'에서 결제한 내역에 대해 환불 가능합니다.(결제 후 7일 이내)
      `
    },
    privacy: {
      title: "개인정보 처리방침",
      content: `
1. 수집하는 개인정보 항목
회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다.
- 수집항목: 닉네임, 휴대폰 번호, 비밀번호, 결제기록 
- 수집방법: 홈페이지 회원가입, 결제 서비스 이용

2. 개인정보의 수집 및 이용목적
- 회원 관리: 본인확인, 개인식별, 불량회원의 부정이용 방지
- 서비스 제공: 포인트 결제, 콘텐츠 이용

3. 개인정보의 보유 및 이용기간
회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.

[전자상거래 등에서의 소비자보호에 관한 법률]
- 계약 또는 청약철회 등에 관한 기록: 5년
- 대금결제 및 재화 등의 공급에 관한 기록: 5년
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년

[통신비밀보호법]
- 접속 로그 기록: 3개월

4. 개인정보 보호책임자
- 책임자: 고세현
- 이메일: rnoc987@naver.com
      `
    }
  };

  // complete - 입력 변경 핸들러
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // complete - 인증번호 발송 함수
  const sendOtp = async () => {
    if (!formData.phoneNumber) return alert("휴대폰 번호를 입력하십시오.");
    try {
      const res = await axios.post('/api/auth/send-otp', { phoneNumber: formData.phoneNumber });
      if (res.data.success) {
        alert("인증 코드가 발송되었습니다.");
        setIsOtpSent(true);
      } else {
        alert("인증 코드 발송에 실패했습니다. 다시 시도하십시오." + res.data.message);
      }

    } catch (err) {
      alert(err.response?.data?.message || "발송 실패: 유효하지 않은 번호이거나 중복된 식별자입니다.");
    }
  };

  // complete - 회원가입 제출 함수
  const handleRegister = async (e) => {
    e.preventDefault();

    // 🚩 [추가] 필수 동의 체크 확인
    if (!agreements.terms || !agreements.privacy || !agreements.age) {
      alert("모든 필수 약관에 동의하셔야 합니다.");
      return;
    }
    
    if (formData.password !== formData.confirmPassword) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      await axios.post('/api/auth/register', formData);
      alert('자격 획득 성공. 전장으로 입장하십시오.');
      navigate('/login');
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || '회원 가입 실패: 서버 통신 오류입니다.');
    }
  };

  // 모든 필수 항목 체크 여부
  const isAllChecked = agreements.terms && agreements.privacy && agreements.age;

  // JSX 반환
  return (
    <div style={styles.container}>
      <div style={styles.headerSection}>
        <h1 style={styles.mainSlogan}>"자격을 증명하라."</h1>
        <p style={styles.subSlogan}>논리의 전장에 참여하기 위한 첫 번째 단계입니다.</p>
      </div>

      <div style={styles.registerBox}>
        <h2 style={styles.logoText}>NEW IDENTITY</h2>
        <p style={styles.registerGuide}>새로운 논객의 정보를 입력하십시오.</p>
        
        <form onSubmit={handleRegister} style={styles.form}>
          {/* 휴대폰 인증 섹션 */}
          <div style={styles.inputGroupContainer}>
            <input 
              name="phoneNumber"
              placeholder="PHONE NUMBER (- 제외)" 
              value={formData.phoneNumber}
              onChange={handleChange} 
              style={styles.inputWithBtn}
              required
            />
            <button type="button" onClick={sendOtp} style={styles.otpBtn}>
              {isOtpSent ? "RE-SEND" : "SEND OTP"}
            </button>
          </div>

          {isOtpSent && (
            <input 
              name="otp"
              placeholder="6-DIGIT VERIFICATION CODE" 
              value={formData.otp}
              onChange={handleChange} 
              style={styles.input}
              required
            />
          )}

          {/* complete - 닉네임 입력 */}
          <input 
            name="nickname"
            placeholder="ID / Nickname - 변경 불가" 
            value={formData.nickname}
            onChange={handleChange} 
            style={styles.input}
            required
          />

          
          <input 
            name="password"
            type="password" 
            placeholder="CODE (Password)" 
            value={formData.password}
            onChange={handleChange} 
            style={styles.input}
            required
          />

          <input 
            name="confirmPassword"
            type="password" 
            placeholder="CONFIRM CODE" 
            value={formData.confirmPassword}
            onChange={handleChange} 
            style={styles.input}
            required
          />

          {/* 🚩 [NEW] 동의 섹션 추가 */}
          <div style={styles.agreementSection}>
            <div style={styles.agreeItem}>
              <input 
                type="checkbox" 
                checked={agreements.terms} 
                onChange={() => setAgreements({...agreements, terms: !agreements.terms})}
                id="terms"
              />
              <label htmlFor="terms" style={styles.agreeLabel}>(필수) 이용약관 및 전장수칙 동의</label>
              <span style={styles.viewLink} onClick={() => setModalContent('terms')}>[보기]</span>
            </div>

            <div style={styles.agreeItem}>
              <input 
                type="checkbox" 
                checked={agreements.privacy} 
                onChange={() => setAgreements({...agreements, privacy: !agreements.privacy})}
                id="privacy"
              />
              <label htmlFor="privacy" style={styles.agreeLabel}>(필수) 개인정보 처리방침 동의</label>
              <span style={styles.viewLink} onClick={() => setModalContent('privacy')}>[보기]</span>
            </div>

            <div style={styles.agreeItem}>
              <input 
                type="checkbox" 
                checked={agreements.age} 
                onChange={() => setAgreements({...agreements, age: !agreements.age})}
                id="age"
              />
              <label htmlFor="age" style={styles.agreeLabel}>(필수) 만 14세 이상임을 확인합니다.</label>
            </div>
          </div>

          {/* 진영 선택 */}
          {/* <select name="faction" value={formData.faction} onChange={handleChange} style={styles.select}>
            <option value="BLUE">FACTION: BLUE</option>
            <option value="RED">FACTION: RED</option>
          </select> */}

          {/* 제출 버튼 */}
          <button type="submit" style={styles.submitBtn}>
            자격 획득 (Register)
          </button>
        </form>

        <div style={styles.footer}>
          <span>이미 자격을 갖추셨습니까?</span>
          <Link to="/login" style={styles.loginLink}>로그인</Link>
        </div>
      </div>

      {/* 🚩 [NEW] 약관 모달창 (PostModal 스타일 계승) */}
      {modalContent && (
        <div style={styles.modalOverlay} onClick={() => setModalContent(null)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>{POLICIES[modalContent].title}</h3>
              <button onClick={() => setModalContent(null)} style={styles.closeBtn}>✕</button>
            </div>
            <div style={styles.modalBody}>
              <pre style={styles.policyText}>{POLICIES[modalContent].content}</pre>
            </div>
          </div>
        </div>
      )}

      <div style={styles.bgDecorationLeft}></div>
      <div style={styles.bgDecorationRight}></div>
    </div>
  );
};

const styles = {
  // 기존 스타일 유지하면서 필요한 부분 추가/수정
  container: {
    height: '100vh', background: '#0a0a0a', color: '#ffffff', display: 'flex',
    flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    fontFamily: "'Noto Sans KR', sans-serif", overflow: 'hidden', position: 'relative'
  },
  headerSection: { textAlign: 'center', marginBottom: '30px', zIndex: 2 },
  mainSlogan: {
    fontSize: '2.5rem', fontWeight: '900', color: '#00d4ff',
    textShadow: '0 0 15px rgba(0, 212, 255, 0.5)', marginBottom: '10px'
  },
  subSlogan: { fontSize: '1rem', color: '#888', letterSpacing: '1px' },
  registerBox: {
    background: 'rgba(30, 30, 30, 0.8)', padding: '40px 50px', borderRadius: '2px',
    border: '1px solid #333', boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
    width: '100%', maxWidth: '400px', zIndex: 2, textAlign: 'center'
  },
  logoText: { fontSize: '1.5rem', fontWeight: 'bold', margin: '0 0 5px 0', color: '#fff', letterSpacing: '3px' },
  registerGuide: { color: '#555', fontSize: '0.85rem', marginBottom: '25px' },
  form: { display: 'flex', flexDirection: 'column', gap: '12px' },
  inputGroupContainer: { display: 'flex', gap: '8px' },
  input: {
    width: '100%', padding: '14px', background: '#121212', border: '1px solid #444',
    color: '#fff', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box'
  },
  inputWithBtn: {
    flex: 1, padding: '14px', background: '#121212', border: '1px solid #444',
    color: '#fff', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box'
  },
  otpBtn: {
    padding: '0 15px', background: 'transparent', border: '1px solid #00d4ff',
    color: '#00d4ff', fontSize: '0.75rem', cursor: 'pointer', transition: 'all 0.3s'
  },
  select: {
    width: '100%', padding: '14px', background: '#121212', border: '1px solid #444',
    color: '#00d4ff', fontSize: '0.9rem', outline: 'none', cursor: 'pointer'
  },
  submitBtn: {
    padding: '15px', background: 'transparent', border: '2px solid #00d4ff',
    color: '#00d4ff', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer',
    marginTop: '10px', transition: 'all 0.3s'
  },
  footer: { marginTop: '25px', fontSize: '0.85rem', color: '#666', display: 'flex', justifyContent: 'center', gap: '10px' },
  loginLink: { color: '#00d4ff', textDecoration: 'none', fontWeight: 'bold' },
  bgDecorationLeft: {
    position: 'absolute', width: '2px', height: '150%', left: '10%', transform: 'rotate(-15deg)', opacity: 0.1,
    background: 'linear-gradient(to bottom, transparent, #00d4ff, transparent)'
  },
  bgDecorationRight: {
    position: 'absolute', width: '2px', height: '150%', right: '10%', transform: 'rotate(-15deg)', opacity: 0.1,
    background: 'linear-gradient(to bottom, transparent, #ff4e50, transparent)'
  },

  // 🚩 [추가된 동의 섹션 스타일]
  agreementSection: {
    textAlign: 'left', marginTop: '10px', padding: '10px', background: 'rgba(0,0,0,0.2)', border: '1px solid #222'
  },
  agreeItem: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' },
  agreeLabel: { fontSize: '0.75rem', color: '#aaa', cursor: 'pointer' },
  viewLink: { fontSize: '0.7rem', color: '#00d4ff', marginLeft: 'auto', cursor: 'pointer', textDecoration: 'underline' },

  // 🚩 [추가된 모달 스타일 - PostModal 계승]
  modalOverlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', 
    backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
  },

  modalContent: {
    backgroundColor: '#121212', border: '1px solid #333', width: '90%', maxWidth: '500px', 
    maxHeight: '80vh', borderRadius: '4px', display: 'flex', flexDirection: 'column'
  },
  modalHeader: {
    padding: '15px 20px', borderBottom: '1px solid #222', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
  },
  modalTitle: { fontSize: '1rem', color: '#00d4ff', margin: 0 },
  closeBtn: { background: 'none', border: 'none', color: '#fff', fontSize: '1.2rem', cursor: 'pointer' },
  modalBody: { padding: '20px', overflowY: 'auto' },
  policyText: { 
    whiteSpace: 'pre-wrap', fontSize: '0.85rem', color: '#ccc', lineHeight: '1.6', fontFamily: 'inherit', margin: 0 
  }
};

export default Register;